//A place for Sales Invoice/Sales Credit shared hooks.

import { useRefFunction } from './hooks';
import setIn from '../components/connectedForm/utils/setIn';
import { BasicConfirmation } from '../components/modals/ConfirmationPrompt';
import React from 'react';

export const usePostConfirmationPrompt = (
  confirmationState,
  setConfirmationState,
  variables,
  setVariables,
  pathForConfirmation
) => {
  const handleConfirmation = useRefFunction((value) => {
    const field = `confirmationResponses.${[confirmationState.meta.confirmationReference]}`;
    const newVariables = setIn(variables, `${pathForConfirmation}.${field}`, value);
    setVariables(newVariables);
    setConfirmationState(null);
  });

  return (
    <BasicConfirmation
      isOpen={!!confirmationState}
      title="Confirmation Required"
      message={confirmationState?.message}
      onCancel={handleConfirmation.bind(null, false)}
      onConfirm={handleConfirmation.bind(null, true)}
    />
  );
};
